import React from "react";
import Slider from "react-slick";

// hola

export default function Empresas() {

    const settings = {
        dots: false,
        infinite: true,
        speed: 5000, // long glide duration
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        autoplay: true,
        autoplaySpeed: 0, // required for continuous linear scroll
        cssEase: 'linear',
        pauseOnHover: false,
        pauseOnFocus: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    initialSlide: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const logos = [

        {
            img: 2
        },
        {
            img: 4
        },

        {
            img: 5
        },
        {
            img: 6
        },
        {
            img: 7
        },
        {
            img: 8
        },
        {
            img: 9
        },
        {
            img: 10
        }
        ,
        {
            img: 11
        }
        ,
        {
            img: 12
        },

        {
            img: 13
        },


    ];

    return (
        <>
            <Slider className="slider__" {...settings}>
                {
                    logos.map((item) => (

                        <div key={item.img}>

                            <div className="logo__wrapper">

                                <img
                                    className={`image-logo--${item.img} w-100`}
                                    src={`${process.env.PUBLIC_URL}/img/empresas/${item.img}.png`}
                                    alt={item.img}
                                />

                            </div>

                        </div>

                    ))
                }
            </Slider>
            {/* <section className="container">
                <h1 className="portfolio-section__title">
                    Empresas
                    <span></span>
                </h1>

            </section> */}
        </>


    );

}